export default __webpack_public_path__ + "static/media/icon--clock.6b408015.svg";